import { CollectionUser, Status, User } from ".";

export class Collection{
    id? : number;
    name: string;
    collectionUsers : CollectionUser[];
    status?: Status;
    createdAt?: Date = new Date();
    createdUser?: User;
    updatedAt?: Date;
    updatedUser?: User;
}
